'use client';
import { BoxIcon } from '@/components/icons/box';
import { SailBoatIcon } from '@/components/icons/sail-bot';
import { FileCheckIcon } from '@/components/icons/file-check';
import { cn } from '@/lib/utils';

interface Step {
  number: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  active: boolean;
}

const steps: Step[] = [
  {
    number: '01',
    title: 'Connect Your Data',
    description:
      'Import leads from spreadsheets, FTP, S3, APIs, and enrichment tools like LinkedIn or ZoomInfo.',
    icon: <BoxIcon />,
    active: true,
  },
  {
    number: '02',
    title: 'Enrich & Clean Automatically',
    description:
      'Our engine validates, enriches, and structures your data in real time.',
    icon: <SailBoatIcon />,
    active: false,
  },
  {
    number: '03',
    title: 'Sync to Your CRM',
    description:
      'Push to Salesforce, Hubspot, Pipedrive, or any other CRM — instantly.',
    icon: <FileCheckIcon />,
    active: false,
  },
];

export const StepsSection = () => {
  return (
    <div className="flex flex-col gap-8 sm:gap-12 lg:gap-[60px] relative">
      {/* Connecting line - hidden on mobile, visible on sm+ */}
      <div className="absolute top-0 left-6 sm:left-12 lg:left-[65px] h-full w-[2px] bg-[#ECEEF3] hidden sm:block"></div>

      {steps.map((step, index) => (
        <div
          key={index}
          className="flex items-start sm:items-center gap-4 sm:gap-8 lg:gap-[62px] relative"
        >
          {/* Active step indicator line */}
          {step.active && (
            <div className="absolute top-0 left-6 sm:left-12 lg:left-[65px] h-full w-[2px] bg-primary-gradient hidden sm:block"></div>
          )}

          {/* Step number */}
          <div className="shrink-0">
            <span className="text-2xl sm:text-3xl lg:text-[36px] leading-8 sm:leading-[30px] lg:leading-[34px] font-poppins font-medium text-[#18191C]">
              {step.number}
            </span>
          </div>

          {/* Step content */}
          <div className="flex-1 min-w-0">
            <div className="mb-2 sm:mb-3">
              <span>{step.icon}</span>
            </div>
            <h3
              className={cn(
                'text-lg sm:text-xl lg:text-2xl leading-6 sm:leading-7 lg:leading-[34px] font-poppins font-semibold text-[#18191C] mb-2 sm:mb-3 lg:my-2',
                {
                  'gradient-text': step.active,
                },
              )}
            >
              {step.title}
            </h3>
            <p className="font-poppins text-[#767A85] text-xs sm:text-sm lg:text-sm leading-5 sm:leading-6 lg:leading-[22px]">
              {step.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
